// @ts-nocheck: converted from JS

import PasswordReset from '@/components/PasswordReset';

export default PasswordReset;
